import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetSiteReportRequest,
	GetSiteListRequest,
	GetSiteReportEmailRequest,
	GetSiteReportEmailAcceptanceRequest,
	GetSiteReportExcelRequest
} from '../requests/SiteReportRequests.js';

export const GET_SITE_REPORT = 'GET_SITE_REPORT';
export const GET_SITE_LIST = 'GET_SITE_LIST';
export const SET_SELECTED_SITE = 'SET_SELECTED_SITE';

const onSetSelectedSite = (value) => ({
	type: SET_SELECTED_SITE,
	selectedSite: value
});

export const SetSelectedSite = (value) => (dispatch) => {
	dispatch(onSetSelectedSite(value));
};

const onGetSiteList = (value) => ({
	type: GET_SITE_LIST,
	siteList: value
});

export const GetSiteList = () => async (dispatch) => {
	await GetSiteListRequest().then(response => {
		dispatch(onGetSiteList(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteReport = (value) => ({
	type: GET_SITE_REPORT,
	siteReport: value
});

export const GetSiteReport = (siteId) => async (dispatch) => {
	await GetSiteReportRequest(siteId).then(response => {
		dispatch(onGetSiteReport(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSiteReportEmail = (siteId, userId) => async (dispatch) => {
	await GetSiteReportEmailRequest(siteId, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSiteReportEmailAcceptance = (siteId, userId) => async (dispatch) => {
	await GetSiteReportEmailAcceptanceRequest(siteId, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSiteReportExcel = (siteId, userId) => async (dispatch) => {
	await GetSiteReportExcelRequest(siteId, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
